var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataUploadArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_back_ios"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.8701 6.98991L2.1001 8.76991L12.0001 18.6599L21.9001 8.75991L20.1301 6.98991L12.0001 15.1199L3.8701 6.98991Z",
    fill: "#323232"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataUploadArrowDown);
export default __webpack_public_path__ + "static/media/data-upload-arrow-down.9c099ce4b4b6f7da70fbc2b432c8f2b5.svg";
export { ForwardRef as ReactComponent };